import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import { Link } from 'react-router-dom';

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: (theme.cssVariables || theme).palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));

interface BreadcrumbItem {
  label: string;
  link?: string;
}

interface NavbarBreadcrumbsProps {
  items: BreadcrumbItem[];
}

const NavbarBreadcrumbs=({ items }: NavbarBreadcrumbsProps)=> {
  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextRoundedIcon fontSize="small" />}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return isLast ? (
          <Typography
            key={item.label}
            color="text.primary"
            sx={{ fontWeight: 600 }}
            variant="body1"
          >
            {item.label}
          </Typography>
        ) : (
          <Typography
            key={item.label}
            variant="body1"
            color="inherit"
            component={item.link ? Link : 'span'}
            to={item.link}
            sx={{ textDecoration: 'none' }} // optional; remove underline if link
          >
            {item.label}
          </Typography>
        );
      })}
    </StyledBreadcrumbs>
  );
};

export default NavbarBreadcrumbs;
